export const ROUTE_HOME_NAME = 'home'
export const ROUTE_STYLE_GUIDE_NAME = 'style-guide'
export const ROUTE_DASHBOARD_SETTINGS_NAME = 'dashboard-settings'
export const ROUTE_LAYOUT_SETTINGS_NAME = 'layout-settings'
export const ROUTE_DASHBOARD_CREATION_NAME = 'dashboard-creation'

export const ROUTE_REPORTS_NAME = 'reports'
export const ROUTE_REPORTS_LIST_NAME = 'reports-list'
export const ROUTE_REPORTS_EDIT_NAME = 'reports-edit'
export const ROUTE_REPORTS_CREATE_NAME = 'reports-create'

export const ROUTE_NOT_FOUND = 'Not Found'

export default [
    {
        path: '/',
        name: ROUTE_HOME_NAME,
        component: () => import(/* webpackChunkName: "home" */ '../views/DashboardPage.vue'),
    },
    {
        path: '/style-guide',
        name: ROUTE_STYLE_GUIDE_NAME,
        component: () => import(/* webpackChunkName: "home" */ '../views/StyleGuide.vue'),
    },
    {
        path: '/dashboard-settings',
        name: ROUTE_DASHBOARD_SETTINGS_NAME,
        component: () => import(/* webpackChunkName: "dashboard-settings" */ '../views/DashboardSettings/DashboardSettings.vue'),
    },
    {
        path: '/dashboard-creation',
        name: ROUTE_DASHBOARD_CREATION_NAME,
        component: () => import(/* webpackChunkName: "dashboard-creation" */ '../views/DashboardCreation/DashboardCreation.vue'),
    },
    /*{
        path: '/generate-pdf',
        name: 'generate-pdf',
        component: () => import(/!* webpackChunkName: "modules" *!/ '@/modules/reports/types/pdf/pdf-wrapper'),
    },*/
    {
        path: '/reports',
        name: ROUTE_REPORTS_NAME,
        redirect: 'reports',
        component: () => import(/* webpackChunkName: "reports" */'@/modules/reports/ReportsLayout.vue'),
        children: [
            {
                path: '',
                name: ROUTE_REPORTS_LIST_NAME,
                component: () => import(/* webpackChunkName: "reports-list" */ '@/modules/reports/pages/RedesignReportList.vue'),
            },
            {
                path: 'edit/:id',
                name: ROUTE_REPORTS_EDIT_NAME,
                component: () => import(/* webpackChunkName: "report-edit" */ '@/modules/reports/pages/RedesignReportEdit.vue'),
            },
            {
                path: 'create',
                name: ROUTE_REPORTS_CREATE_NAME,
                component: () => import(/* webpackChunkName: "report-create" */ '@/modules/reports/pages/RedesignReportCreate.vue'),
            },
        ],
    },
    {
        path: '*',
        name: ROUTE_NOT_FOUND,
        meta: {
            skipOrganizationCheck: true,
            productionReady: true,
        },
        beforeEnter () {
            window.location = '/'
        }
    },
]
